export default `
	guid
	car_type
	car_fuel_type
	car_length_min
	car_length_max
	car_width_min
	car_width_max
	car_height_min
	car_height_max
	car_wheelbase_min
	car_wheelbase_max
	car_weight_min
	car_weight_max
`;
